function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGreenCheckmark = function SvgGreenCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.084 -.786)",
    style: {
      opacity: 0.9089
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15,
      enableBackground: "new"
    },
    width: 317,
    height: 317,
    xlinkHref: "FB0E9F3F3EAA1916.png",
    transform: "matrix(.0666 0 0 .0666 .266 .12)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.8,
    cy: 10.2,
    r: 9.3,
    style: {
      fill: "#66bb46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1 6.3-4.3 7.4c-.2.4-.7.5-1 .3l-.2-.2-2.7-3.3c-.1-.2-.1-.4.1-.6.2-.1.4-.1.5 0l3.3 2.7-1.2.1 5.2-6.8c.1-.1.3-.1.4-.1-.1.2-.1.4-.1.5z",
    style: {
      fill: "#f7f9fc"
    }
  })));
};

export { SvgGreenCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7b3BhY2l0eTowLjkwODk7fQoJLnN0MXtmaWxsOiM2NkJCNDY7fQoJLnN0MntmaWxsOiNGN0Y5RkM7fQo8L3N0eWxlPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4wODM5ODUgLS43ODU1NDYpIiBjbGFzcz0ic3QwIj4KCQoJCTxpbWFnZSBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTtvcGFjaXR5OjAuMTU7ZW5hYmxlLWJhY2tncm91bmQ6bmV3ICAgIDsiIHdpZHRoPSIzMTciIGhlaWdodD0iMzE3IiB4bGluazpocmVmPSJGQjBFOUYzRjNFQUExOTE2LnBuZyIgIHRyYW5zZm9ybT0ibWF0cml4KDYuNjU5MjA3ZS0wMiAwIDAgNi42NTkyMDdlLTAyIDAuMjY1OCAwLjEyKSI+Cgk8L2ltYWdlPgoJPGc+CgkJPGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iMTAuOCIgY3k9IjEwLjIiIHI9IjkuMyIvPgoJCTxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xNS4xLDYuM2wtNC4zLDcuNHYwYy0wLjIsMC40LTAuNywwLjUtMSwwLjNjLTAuMS0wLjEtMC4xLTAuMS0wLjItMC4ybC0yLjctMy4zYy0wLjEtMC4yLTAuMS0wLjQsMC4xLTAuNgoJCQljMC4yLTAuMSwwLjQtMC4xLDAuNSwwbDMuMywyLjdsLTEuMiwwLjFsNS4yLTYuOGMwLjEtMC4xLDAuMy0wLjEsMC40LTAuMUMxNS4xLDYsMTUuMSw2LjIsMTUuMSw2LjN6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";